import { Base } from './base.model';

export class PremiumAcreageUser extends Base {
  public email: string;
  public submittedDate: Date;
  public contacted: boolean;
  public referrerCode: number;
}
